import React, { FC, useCallback, useState } from 'react'
import { createUseStyles } from 'react-jss'
import { runAutoPairing } from '../../../../common/logic/auto-pairing-logic'
import { getNow } from '../../../../common/logic/date-logic'
import { ListItem } from '../../../list-item/ListItem'
import { LoadingOverlay } from '../../../loading-overlay/LoadingOverlay'
import { StyledRefreshIcon } from '../../../styled-icons/styled-refresh-icon/StyledRefreshIcon'

type AdminRunAutoPairProps = {}

export const AdminRunAutoPair: FC<AdminRunAutoPairProps> = () => {

	// hooks
	const styles = useStyles()
	const [loading, setLoading] = useState<boolean>(false)

	// event handlers
	const handleListItemClick = useCallback(() => {
		setLoading(true)
		const thisWeek = getNow().startOf('week').unix()
		runAutoPairing(thisWeek).then(() => {
			setLoading(false)
		})
	}, [])

	return (
		<ListItem onClick={handleListItemClick}>
			<StyledRefreshIcon />
			<h3>Run Auto Pairing</h3>
			<LoadingOverlay loading={loading} />
		</ListItem>
	)
}

const useStyles = createUseStyles({
	adminRunAutoPair: {
		display: 'grid'
	}
})